import './index.scss'
import { Icon, Input } from 'antd';
import React, { useState } from 'react'
import { InputProps } from 'antd/lib/input';
import { IconEyePasswordClose, IconEyePasswordOpen } from '@shares/DMPIcon';

type TFormInputCustomPassword = InputProps & {
  onCopy?: () => void
}

export const FormInputPasswordCustom = ({ onCopy, ...inputProps }: TFormInputCustomPassword) => {
  const [visible, setVisible] = useState(false);
  const toggleVisible = () => setVisible(!visible);

  return (
    <Input
      {...inputProps}
      className='ant-input-custom-suffix mt8'
      type={visible ? 'text' : 'password'}
      suffix={
        <div style={{
          display: 'flex',
          alignItems: 'center',
          transition: 'opacity 0.3s ease',
          // opacity: inputProps?.value ? 1 : 0,
          pointerEvents: inputProps?.value ? 'auto' : 'none',
        }}>
          {visible ? (
            <Icon onClick={toggleVisible} component={() => <IconEyePasswordOpen style={{ color: 'var(--primary-color)', cursor: 'pointer' }} />} />
          ) : (
            <Icon onClick={toggleVisible} component={() => <IconEyePasswordClose style={{ color: 'var(--primary-color)', cursor: 'pointer' }} />} />
          )}
        </div>
      }
    />
  )
}
